import React from 'react';
import { Alert, Box, Typography, Paper } from '@mui/material';
import { LockOutlined, ContactSupport } from '@mui/icons-material';
import { useMenusPermitidos } from '../hooks/useMenusPermitidos';

interface ProtecaoAcessoProps {
  children: React.ReactNode;
  tela: string;
  tipo?: 'visualizacao' | 'alteracao';
  fallback?: React.ReactNode;
}

const ProtecaoAcesso: React.FC<ProtecaoAcessoProps> = ({ 
  children, 
  tela, 
  tipo = 'visualizacao',
  fallback 
}) => {
  const { temPermissaoMenu, loading } = useMenusPermitidos();

  if (loading) {
    return <Box>Verificando permissões...</Box>;
  }

  const hasAccess = temPermissaoMenu(tela);

  if (!hasAccess) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '400px',
          p: 4 
        }}
      >
        <LockOutlined sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        
        <Typography variant="h5" gutterBottom color="text.primary">
          Acesso Restrito
        </Typography>
        
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ mb: 3, maxWidth: 500 }}>
          Você não tem permissão para acessar esta funcionalidade.
        </Typography>

        <Alert severity="info" sx={{ maxWidth: 600 }}>
          <Typography variant="body2">
            <ContactSupport sx={{ verticalAlign: 'middle', mr: 1 }} />
            Para obter acesso, entre em contato com seu superior ou administrador do sistema. 
            Eles podem atribuir as permissões necessárias ao seu perfil de usuário.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtecaoAcesso;
